import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "benefitshow"
}
const _hoisted_2 = { class: "benefitshow__container" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "benefitshow__results" }
const _hoisted_5 = {
  key: 0,
  class: "benefitshow__cards"
}
const _hoisted_6 = {
  key: 1,
  class: "benefitshow__cards"
}
const _hoisted_7 = { class: "benefitshow__card-price" }
const _hoisted_8 = { class: "benefitshow__card-title" }
const _hoisted_9 = { class: "benefitshow__card-subtitle" }
const _hoisted_10 = { class: "benefitshow__card benefitshow__card--large" }
const _hoisted_11 = { class: "benefitshow__card-large-grid" }
const _hoisted_12 = { class: "benefitshow__card-large-price" }
const _hoisted_13 = { class: "benefitshow__card-large-price" }
const _hoisted_14 = { class: "benefitshow__card-large-total" }
const _hoisted_15 = { class: "benefitshow__card-large-price" }
const _hoisted_16 = {
  key: 0,
  class: "benefitshow__module-text"
}
const _hoisted_17 = { class: "col-benefit_calculator" }

import {
  computed, onBeforeUnmount, onMounted, reactive, ref, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import BenefitCalculator from '@/components/BenefitCalculator.vue';
// eslint-disable-next-line import/extensions,import/no-unresolved
import Benefit from '@/interfaces/BenefitInterface';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitshowPage',
  setup(__props) {

const route = useRoute();
const store = useStore();
const stickyCont = ref();

const isFetching = computed(() => store.getters['benefitshow/loading']);
const benefits = computed<Benefit | null>(() => store.getters['benefitshow/values'][0] || null);

const routeQueryVars = computed(() => route.query);
const routeParamVars = computed(() => route.params);

const basePrice = computed(() => formatNumber((benefits.value?.base || 0) * 1.19, 2));
const workingPrice = computed(() => formatNumber((benefits.value?.working || 0) * 1.19, 2));
const nnl = computed(() => formatNumber((benefits.value?.network || 0) * 1.19, 2));
const concessionFee = computed(() => formatNumber((benefits.value?.concessionFee || 0) * 1.19, 2));
const yearlyPrice = computed(() => formatNumber((benefits.value?.total || 0) * 1.19, 2));

const benefitCards = computed(() => {
  if (!benefits.value || (
    benefits.value.base === 0
    && benefits.value.working === 0
    && benefits.value.network === 0
    && benefits.value.concessionFee === 0
  )) return [];
  return [
    {
      title: 'Rabatt Netznutzung Grundpreis brutto',
      subtitle: 'vorbehaltlich korrekter Anmeldung beim Netzbetreiber',
      value: basePrice.value,
      unit: '€/Jahr',
    },
    {
      title: 'Rabatt Netznutzung Arbeitspreis brutto',
      subtitle: 'vorbehaltlich korrekter Anmeldung beim Netzbetreiber',
      value: workingPrice.value,
      unit: 'Cent/kWh',
    },
    {
      title: 'Rabatt Netzumlagen brutto',
      subtitle: 'vorbehaltlich Mengennachweis bis zum 31.03. im Folgejahr',
      value: nnl.value,
      unit: 'Cent/kWh',
    },
    {
      title: 'Rabatt Konzessionsabgabe brutto',
      subtitle: 'vorbehaltlich Anwendung KA für Heizstrom',
      value: concessionFee.value,
      unit: 'Cent/kWh',
    },
  ];
});

const benefitshow = reactive({
  params: {
    hasControllableDevice: parseInt(`${routeQueryVars.value?.controllableDevice || 0}`, 10),
    type: routeQueryVars.value.type,
    seperatedMeasurement: parseInt(`${routeQueryVars.value?.meter || 0}`, 10),
    after2024: parseInt(`${routeQueryVars.value?.installation || 0}`, 10),
    hasImsys: parseInt(`${routeQueryVars.value?.smart || 0}`, 10),
    module: routeParamVars.value.module,
    postcode: routeParamVars.value.postcode,
    city: routeQueryVars.value.stadt,
    street: routeQueryVars.value.strasse,
    houseNumber: routeQueryVars.value.hausnummer,
    usage: parseInt(`${routeParamVars.value.usage}`, 10),
  },
});

const showModule3Text = computed(() => {
  const { params } = benefitshow;
  return params.hasControllableDevice === 1
      && (params.type === 'heatPump' || params.type === 'emobility')
      && params.seperatedMeasurement === 0
      && params.after2024 === 1
      && params.hasImsys === 1
      && params.module === '3';
});

const setBenefitshowParams = () => {
  benefitshow.params.hasControllableDevice = parseInt(`${routeQueryVars.value?.controllableDevice || 0}`, 10);
  benefitshow.params.type = routeQueryVars.value.type;
  benefitshow.params.seperatedMeasurement = parseInt(`${routeQueryVars.value?.meter || 0}`, 10);
  benefitshow.params.after2024 = parseInt(`${routeQueryVars.value?.installation || 0}`, 10);
  benefitshow.params.hasImsys = parseInt(`${routeQueryVars.value?.smart || 0}`, 10);
  benefitshow.params.module = routeParamVars.value.module;
  benefitshow.params.city = routeQueryVars.value.stadt;
  benefitshow.params.street = routeQueryVars.value.strasse;
  benefitshow.params.houseNumber = routeQueryVars.value.hausnummer;
  benefitshow.params.postcode = routeParamVars.value.postcode;
  benefitshow.params.usage = parseInt(`${routeParamVars.value.usage}`, 10);
};

const fetchBenefits = () => {
  store.dispatch('benefitshow/fetch', benefitshow.params);
};

watch(() => ({
  ...routeParamVars.value,
  ...routeQueryVars.value,
}), () => {
  setBenefitshowParams();
  fetchBenefits();
}, { deep: true });

const setStickyTop = () => {
  const header = document.querySelector('header');
  if (stickyCont.value && header) {
    stickyCont.value.style.top = `${header.offsetHeight}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  setStickyTop();
  fetchBenefits();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setStickyTop);
  window.removeEventListener('load', setStickyTop);
});

return (_ctx: any,_cache: any) => {
  const _component_BasePageHeader = _resolveComponent("BasePageHeader")!
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isFetching.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_BasePageHeader, null, {
            title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Ihr Preisvorteil §14a EnWG ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (benefitCards.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Auf Basis Ihrer Angaben können wir Ihnen leider keinen Preisvorteil ausgeben "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefitCards.value, (card, inx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `card-${inx}`,
                          class: "benefitshow__card"
                        }, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(card.value) + " " + _toDisplayString(card.unit), 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(card.title), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(card.subtitle), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "benefitshow__card-large-title" }, " Rabattierung ", -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(basePrice.value) + " €/Jahr ", 1),
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "benefitshow__card-large-label" }, " Grundpreis brutto ", -1))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(workingPrice.value) + " Cent/kWh ", 1),
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "benefitshow__card-large-label" }, " Arbeitspreis brutto ", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(yearlyPrice.value) + " €/Jahr ", 1),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "benefitshow__card-large-label" }, " Rabatt für Ihren angegebenen Verbrauch ", -1))
                        ])
                      ]),
                      (showModule3Text.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Der Rabatt des Arbeitspreises der Netznutzung ist abhängig von Ihrem Verbrauchsverhalten in den von Ihrem Netzbetreiber veröffentlichten Zeitfenstern. Die Vergünstigungen durch das Modul 3 erhalten Sie aktuell nur mit dem Tarif ÖKO FLEX STROM im SWSee Netzgebiet. "))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    ref_key: "stickyCont",
                    ref: stickyCont,
                    class: "col-benefit_calculator__sticky"
                  }, [
                    _createVNode(BenefitCalculator, {
                      "preselected-options": benefitshow.params,
                      type: "component"
                    }, null, 8, ["preselected-options"])
                  ], 512)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isFetching.value)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})